module.exports = __webpack_public_path__ + "media/images/emblems/Porrentruy-blason-1aacf7398eadd27597a1362d28b8669b.png";